export enum RuleUiCode {
    $ROW_STATE_NEW = '$rsn',
    ROW_STATE_NEW = 'rsn',
    $ROW_STATE_EDIT = '$rse',
    ROW_STATE_EDIT = 'rse',
    $ROW_SNAPSHOT_ID = '$rsid',
    ROW_SNAPSHOT_ID = 'rsid',
}
